const common = require("lib/labels/_common");

module.exports = {
  registrationList: {
    title: {
      en: "Registrations",
      fr: "Inscriptions"
    },
    remove: common.remove,
    sendAgain: {
      en: "Send again",
      fr: "Renvoyer le mail"
    },
    send: {
      en: "Send validation mail",
      fr: "Envoyer le mail de validation"
    },
    email: common.email,
    fistName: {
      en: "Fistname",
      fr: "Prénom"
    },
    lastName: {
      en: "Lastname",
      fr: "Nom"
    },
    phone: {
      en: "Phone",
      fr: "Téléphone"
    },
    mobile: {
      en: "Mobile",
      fr: "Mobile"
    }
  },
  validateForm: {
    stepTitle: {
      en: "User validation",
      fr: "Accepter l'utilisateur"
    },
    title: {
      en: "Member profile",
      fr: "Profil du membre"
    },
    profile: common.profile
  }
};
